export interface ConsentContextType {
  acceptConsent: () => Promise<void>;
  isAcceptConsentFetching: boolean;
  isConsentStatusFetching: boolean;
  isConsentAccepted: boolean | undefined;
  setIsConsentAccepted: (value: boolean) => void;
  tenant: string;
}

export const ConsentContextSymbol = Symbol('ConsentContext');
